module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }